import { render, staticRenderFns } from "./PieGraph.vue?vue&type=template&id=99e0048c&scoped=true&"
import script from "./PieGraph.vue?vue&type=script&lang=js&"
export * from "./PieGraph.vue?vue&type=script&lang=js&"
import style0 from "./PieGraph.vue?vue&type=style&index=0&id=99e0048c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99e0048c",
  null
  
)

export default component.exports